import React from "react";
import { Box, TextField } from "@mui/material";
import {
  ThemeProvider,
  StyledEngineProvider,
  createTheme,
} from "@mui/material/styles";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import { Button } from "@mui/material";
import { ClearAll } from "@mui/icons-material";
import { useViewport } from "../../components/CustomHooks/useViewport";
import FilterVessel from "../../components/FilterVessel/FilterVessel";
import { getMaxDate, getMinDate } from "../../constants/dateFunctions";

const theme = createTheme({
  typography: {
    fontFamily: "Proximanova Reg, sans-serif",
    button: {
      textTransform: "none",
      borderRadius: "5px",
    },
    variant: "title",
  },
  components: {
    // * current tab
    MuiTab: {
      styleOverrides: {
        root: {
          "&.Mui-selected": {
            color: "white",
          },
        },
      },
    },
    // * controls styles for both tabs
    MuiTabs: {
      styleOverrides: {
        indicator: {
          backgroundColor: "red",
          height: 3,
        },
      },
    },
    // * Displays the selected date
    MuiPickersToolbar: {
      styleOverrides: {
        root: {
          backgroundColor: "#3f51b5",
          "& .MuiTypography-root": {
            color: "white",
          },
        },
      },
    },
    // * tabs allow switching between day and time
    MuiDateTimePickerTabs: {
      styleOverrides: {
        root: {
          backgroundColor: "#3f51b5",
        },
      },
    },
  },
});

export const Filter = ({
  tripId,
  vesselPermit,
  sailDate,
  landDate,
  handleTripChange,
  handleVesselChange,
  handleDateChange,
  handleFilterClear,
  preferences,
}) => {
  const width = useViewport();
  const isMobile = width < 620;

  return (
    <div className={"left-edge"}>
      <Box
        display="flex"
        flexWrap="wrap"
        justifyContent="center"
        alignItems="center"
      >
        {!isMobile && (
          <Box p={1}>
            <TextField
              variant="standard"
              label="Trip"
              className="number-of-input"
              value={tripId ? tripId : ""}
              name="tripID"
              type="number"
              style={{ width: 150 }}
              InputProps={{ inputProps: { min: 0, max: 999999 } }}
              onChange={(e) => handleTripChange(e)}
            />
          </Box>
        )}
        <Box p={1}>
          <FilterVessel
            vesselPermit={vesselPermit}
            vesselOptions={preferences}
            handleVesselChange={handleVesselChange}
          />
        </Box>
        <Box p={1}>
          <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <MobileDatePicker
                  label="Sail Date"
                  inputFormat="MM/DD/YYYY"
                  value={sailDate}
                  onChange={(date) => handleDateChange("sailDate", date)}
                  maxDate={getMaxDate()}
                  minDate={getMinDate()}
                  style={{ width: "200px" }}
                  renderInput={(params) => (
                    <TextField {...params} variant="standard" />
                  )}
                />
              </LocalizationProvider>
            </ThemeProvider>
          </StyledEngineProvider>
        </Box>
        {!isMobile && (
          <Box p={1}>
            <StyledEngineProvider injectFirst>
              <ThemeProvider theme={theme}>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <MobileDatePicker
                    label="Land Date"
                    inputFormat="MM/DD/YYYY"
                    value={landDate}
                    onChange={(date) => handleDateChange("landDate", date)}
                    maxDate={getMaxDate()}
                    minDate={getMinDate()}
                    style={{ width: "200px" }}
                    renderInput={(params) => (
                      <TextField {...params} variant="standard" />
                    )}
                  />
                </LocalizationProvider>
              </ThemeProvider>
            </StyledEngineProvider>
          </Box>
        )}
        <Box p={1}>
          <Button
            variant="contained"
            color="primary"
            startIcon={<ClearAll />}
            onClick={handleFilterClear}
          >
            Clear Filters
          </Button>
        </Box>
      </Box>
    </div>
  );
};
